
document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById('anchor-links-container');
    const headers = document.querySelectorAll('.page-container h2');

    if (container) {
        headers.forEach((header, index) => {
            if (!header.id) {
                header.id = `section-${index}`;  // Ensure each h2 has a unique ID
            }

            const link = document.createElement('a');
            link.href = `#${header.id}`;
            link.textContent = header.textContent;
            link.classList.add("anchor-link");  // Use class for styling

            container.appendChild(link);
        });
    }
});
